// Petits utilitaires DOM. La visibilité passe par l'attribut [hidden] (preflight Tailwind v4 : display:none !important)
export const $ = (id) => {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Élément introuvable : #${id}`);
  return el;
};

export const show = (el) => { el.hidden = false; };
export const hide = (el) => { el.hidden = true; };

export function escapeHTML(str) {
  return String(str ?? '').replace(/[&<>'"]/g,
    (tag) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag]));
}
